export default __webpack_public_path__ + "static/media/transition_icon.2391d329.svg";